import Icon from 'components/Icon';

export default function DownloadBox({ url, filename, onReset, stats }) {
  const handleDownload = () => {
    const a = document.createElement('a');
    a.href = url; a.download = filename;
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
  };

  if (!url) return null;
  return (
    <div className="dl-box">
      <div className="dl-icon"><Icon name="check" size={28} /></div>
      <h3>File Ready to Download!</h3>
      <p>Your file <strong>{filename}</strong> has been processed successfully.</p>
      {stats && (
        <div style={{ display:'flex', gap:20, justifyContent:'center', flexWrap:'wrap', margin:'14px 0', padding:'14px 20px', background:'rgba(255,255,255,0.7)', borderRadius:'var(--r)', border:'1px solid #6ee7b7' }}>
          {stats.map((s, i) => (
            <div key={i} style={{ textAlign:'center' }}>
              <div style={{ fontSize:18, fontWeight:800, color:'#047857' }}>{s.value}</div>
              <div style={{ fontSize:11, color:'#065f46', fontWeight:600, textTransform:'uppercase', letterSpacing:'.4px' }}>{s.label}</div>
            </div>
          ))}
        </div>
      )}
      <div className="dl-actions">
        <button className="btn btn-success btn-lg" onClick={handleDownload}>
          <Icon name="download" size={18} />Download {filename}
        </button>
        <button className="btn btn-outline btn-lg" onClick={onReset}>
          <Icon name="refresh" size={18} />Process Another File
        </button>
      </div>
    </div>
  );
}
